export function generateUID() {
    // ~155 bits of entropy

    function random() {
        const array = new Uint32Array(1)
        return window.crypto.getRandomValues(array)[0]
    }

    const chars = '1234567890abcdefghijklmnopqrstuvwxyz'
    const id = []

    for (let i = 0; i < 30; i++) {
        id.push(chars[random() % chars.length])
    }

    return id.join('')
}
